
let events = []

export default {
    /**
     * Add a listener to respond to events of a given name.
     *
     * @param {string} eventName Event name
     * @param {function} callback Listener function
     */
    on: function (eventName, callback) {
        if (events[eventName] === undefined) {
            events[eventName] = []
        }

        events[eventName].push(callback)
    },

    /**
     * Trigger all callbacks for a given name.
     *
     * @param {string} eventName Event name
     * @param {mixed} props Data to send to each callback
     */
    emit: function (eventName, props) {
        if (events[eventName] !== undefined) {
            events[eventName].map(callback => {
                callback(props)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/utilities/event-manager.js